import React, { useEffect } from 'react';
import styles from './MandateTemplate.module.css';
import SearchBar from '../../../../Components/SearchBar/SearchBar';
import { useAppSelector } from '../../../../Redux/Store/Store';
import { getClient } from '../../../../Redux/Store/Slices/client';
import SelectionListPane, { Category } from '../../../../Components/Utils/SelectionListPane/SelectionListPane';
import { axiosInstance } from '../../../../Authentication/AxiosInterceptor';
import Button from '../../../../Components/Utils/Button/Button';
import { useParams, useNavigate } from 'react-router-dom';
import { PagedRequest } from '../../../../Types/Paging/PagedRequest';
import Paging from '../../../../Components/Utils/Paging/Paging';
import { PagedResponse } from '../../../../Types/Paging/PagedResponse';
import { useWorkflowContext } from '../../../../Hooks/useWorkflowContext';

export type MandateTemplateRequest = {
  templateId: string;
  clientId: string;
  subsetId?: string;
  add: boolean;
};

type MandateTemplateProps = object;

const MandateTemplate = ({}: MandateTemplateProps) => {
  const { templateId, templateTitle } = useParams<{ templateId: string; templateTitle: string }>();
  const navigate = useNavigate();
  const { getWorkflowPath, isAdminContext } = useWorkflowContext();

  const client = useAppSelector(getClient);

  const [clients, setClients] = React.useState<Category<string>[]>([]);
  const [searchTerm, setSearchTerm] = React.useState<string>('');
  const [activePage, setActivePage] = React.useState<number>(1);
  const [pageCount, setPageCount] = React.useState<number>(0);

  const pageSize = 20;

  const getData = async () => {
    const request: PagedRequest = {
      pageNumber: activePage,
      pageSize: pageSize,
      searchTerm: searchTerm,
    };

    const response = await axiosInstance.post(`GetMandateClientsInfo/${templateId}`, request);
    const data = await response.data as PagedResponse<Category<string>>;
    setClients(data.items);
    setPageCount(data.totalCount ? Math.ceil(data.totalCount / pageSize) : 0);
  };

  const mandateTemplateHandler = async (clientId: string, add: boolean) => {
    try {
      const request: MandateTemplateRequest = {
        templateId: templateId || '',
        clientId: clientId,
        add: add,
      };

      await axiosInstance.post(`MandateTemplateToClient`, request);
    } catch (err) {
      console.error('Failed to mandate template:', err);
    }
  };

  const handleChange = (updatedCategory: Category<string>) => {
    setClients((current) => {
      const oldCat = current.find((c) => c.id === updatedCategory.id);
      if (oldCat) {
        updatedCategory.data.forEach((item) => {
          const oldItem = oldCat.data.find((i) => i.id === item.id);
          if (oldItem && oldItem.selected !== item.selected) {
            mandateTemplateHandler(item.value, item.selected);
          }
        });
      }

      return current.map((cat) =>
        cat.id === updatedCategory.id ? updatedCategory : cat
      );
    });
  };

  useEffect(() => {
    getData();
  }, [searchTerm, activePage, templateId]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Mandate Template: {templateTitle}</h1>
        <Button clickHandler={() => navigate(getWorkflowPath(templateId || '', templateTitle || '', 'additional-information'))} colour="#52BFA2" textColour="#fff">
          Back: Additional Information
        </Button>
      </div>
      <SearchBar value={searchTerm} onChange={setSearchTerm} type="" />
      <div className={styles.selectionPane}>
        <SelectionListPane categories={clients} onChange={handleChange} selectAllDisabled={true} maxHeight="350px" />
      </div>
      <Paging activePage={activePage} pageCount={pageCount} pageChanged={setActivePage} />
    </div>
  );
};

export default MandateTemplate;